import { Transport } from './transport';
import { Vehicle } from './vehicle';
import { Price } from './price';
import { Addon } from './addon';
export class Reservation {

    public id?: number;
    public Id?: number;
    public pickup_datetime?: string;
    public pickup_time?: string;
    public dropoff_date?: string;
    public dropoff_time?: string;
    public first_name?: string;
    public last_name?: string;
    public phone_client?: string;
    public email_client?: string;
    public country_code?: string;
    public pickup_name?: string;
    public pickup_latitude?: number;
    public pickup_longitude?: number;
    public dropoff_name?: string;
    public dropoff_latitude?: number;
    public dropoff_longitude?: string;
    public tracing_number?: string;
    public booking_status?: string;
    public adults?: number;
    public child?: number;
    public line_airport_pickup?: string;
    public number_airport_pickup?: string;
    public time_airport_pickup?: string;
    public cruise_name_pickup?: string;
    public landing_time_pickup?: string;
    public train_number_pickup?: string;
    public train_arrival_time_pickup?: string;
    public address_pickup?: string;
    public type_pickup?: string;
    public type_dropoff?: string;
    public line_airport_dropoff?: string;
    public number_airport_dropoff?: string;
    public time_airport_dropoff?: string;
    public cruise_name_dropoff?: string;
    public landing_time_dropoff?: string;
    public train_number_dropoff?: string;
    public train_arrival_time_dropoff?: string;
    public address_dropoff?: string;
    public comment?: string;
    public type?: string;
    public reservation_type?: string;
    public online_status?: string;
    public invoice_status?: string;
    public payment_method?: string;
    public payment?: string;
    public collect_money?: string;
    public collect_money_price?: string;
    public provider_name?: string;
    public wp_transfer_booking_id?: number;
    public cancelled_at?: Date;
    public buff_time?: number;
    public service_date?: string;
    public from_type?: string;
    public to_type?: string;
    public provider_online_status?: string;

    public addons?: Array<Addon>;
    public prices?: Price;
    public vehicle?: Vehicle;
    public transport?: Transport;

}